import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import {
  createCustomerValidationForm,
  ICreateCustomer,
} from "../../utils/validationSchemas";
import CustomerForm from "./CustomerForm";

const EditCustomer = (props: any) => {
  const { handleEdit, isLoading, data } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    clearErrors,
    control,
  } = useForm<ICreateCustomer>({
    resolver: yupResolver(createCustomerValidationForm),
    defaultValues: async () => {
      return {
        full_name: data?.full_name,
        address: data?.address,
        vat_pan: data?.vat_pan,
        primary_contact: data?.primary_contact,
        secondary_contact: data?.secondary_contact,
        email: data?.email ? data?.email : null,
      };
    },
  });

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <CustomerForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        control={control}
      />
    </FormLayout>
  );
};

export default EditCustomer;
